module.exports = __webpack_public_path__ + "static/img/wechat_channels.7bfcdfa7.svg";